import PublicLayout from '../components/layouts/PublicLayout';
import { Container, Row, Col } from 'reactstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router'

function CustomerFaq({data}) {
    const [loading, setLoading] = useState(false); 
	const router = useRouter();

	return (
        <>
         	<Head>
	            <meta name="keywords" content={data ? data.keywords : ''} />
	            <title>{data ? data.title : ''}</title>
	            <meta name="description" content={data ? data.description : ''} />
	            <link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
	        </Head>
			  <div className="banner_breadcrumb_section" id="terms">
				<div id="spinner" className="spinner_req_review" style={{"display": loading ? "block" : "none"}}>
						<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
					</div>
				  <Container fluid="xl">
					<h1 className="main-heading-lg">Terms for Professionals</h1>
					</Container>
				  </div>
				  <Container fluid="xl">
					  <div className="about_sec1-intro terms-section-set padding-set" >
						  <div className="main-top">
							<p className="text-center">These rules cover your legal rights and liabilities as a professional using Toprow. When you register an account and create a profile, you are agreeing to abide by these rules.</p>
						  </div>
						 <div className="content-wrap-set">
							<h4>
								1. User Permissions
							</h4>
							<p>
							Everything that happens through your account are your own actions. You can allow other people to use your account as long as you are responsible for what they do. Such people could include authorized employees or agents acting on behalf of your agency. When you allow someone else to use your account, you agree that they are acting on your behalf and you are liable for their actions and omissions. If the authorized user violates our Terms of Use or other site rules, this may affect your ability to continue using our services and can lead to account closure in some cases.
							</p>
						  </div>
						  <div className="content-wrap-set in-wrap">
							<h4>
								1.2. Identity and Verifications
							</h4>
							<p>
							You will be required to verify your account at the time of registration and periodically after that. Such verification may include official government or legal documents that confirm your identity, location, and your skill and experience. We may also want to confirm your email address and ownership of your agency in line with the applicable laws. By opening an account on Toprow, you authorize Toprow acting directly or through third parties to contact you with requests for such information. You must cooperate by providing this information in a timely manner. Some account features may be temporarily suspended until verifications are completed.
							</p>
						  </div>
						  <div className="content-wrap-set in-wrap">
							<h4>
								1.3. Usernames and Passwords
							</h4>
							<p>
							You must provide a username and password when you create an account. It is your responsibility to keep these safe and ensure that others do not have access to your account. If you suspect that someone has accessed your account without your permission, you must notify us immediately. You should not access another vendor&#39;s account with their username or password or pose as them to offer services to businesses.
							</p>
						  </div>

						  <div className="content-wrap-set">
							<h4>
								2. Your Relationship with Toprow
							</h4>
							<p>
							Toprow exists to match you with the best clients and businesses who need your skills and expertise as a vendor or an agency. You or your business are not an extension of Toprow. You are an independent business using Toprow for purposes of acquiring new clients, getting more leads and closing more business. As such, Toprow is not responsible for content that you create or post on our platforms. It is your responsibility to ensure the accuracy and authenticity of such content.
							</p>
						
							<p>
							Toprow is not responsible for ensuring that businesses choose your services or that you perform and complete projects that you have procured on our platform. We do not guarantee any user&#39;s services and nothing will create an employment, agency or joint venture relationship between you and Toprow. Your ability to complete contracts created on Toprow is your sole responsibility as is any liability arising from your inability to complete them.
							</p>
						
							<p>
							Toprow cannot offer you advice on whether or not to work with a business. Who to work with and what projects to take on are your decisions to make. Any users you authorize acts on your behalf and are covered within these terms.
							</p>
						  </div>

						  <div className="content-wrap-set in-wrap">
							<h4>
								2.2. Incomes Accruing and Taxes Payable
							</h4>
							<p>
							As a professional on Toprow, you agree that you are solely responsible for taxes accruing on income you acquire on Toprow. It is your sole duty to carry out such tasks as invoicing, reporting and remitting taxes and other charges that accrued on payments you receive on Toprow.
							</p>
						  </div>

						  <div className="content-wrap-set in-wrap">
							<h4>
								2.3. Audits
							</h4>
							<p>
							If an audit of Toprow is scheduled to be conducted, you agree to cooperate with the relevant authorities and third parties acting on behalf of Toprow. You may be required to provide copies of your tax returns and other documents for these purposes. You may also be requested to show records of your business transactions on Toprow and documents verifying the authenticity of your business and the information you have made available to Toprow.
							</p>
						  </div>

						  <div className="content-wrap-set">
							<h4>
								3. Disputes Arising
							</h4>
							<p>
							In the event that disputes arise over projects that you complete on Toprow, you agree to report such disputes to Toprow&#39;s support and cooperate with any instructions you are given for amicable resolutions between you and your client.
							</p>
							
							<p>
							If you choose to invoke a court&#39;s jurisdiction or seek relief through an arbitrator over disputes on Toprow or any other issue, you agree to provide sufficient prior notice to Toprow. For court orders, such notice would be at least five days before the hearing date. Such order must state as a precondition to any obligation directed at Toprow on the order that Toprow would be paid any amounts accruing either on the project in dispute or on any services that Toprow may be required to complete under such order.
							</p>
						  </div>

						  <div className="content-wrap-set">
							<h4>
								4. Confidentiality
							</h4>
							<p>
							Vendors and businesses can agree on terms governing their contracts and projects including confidentiality. In the event that they do not make any provisions for the exchange of confidential information, these terms would apply.
							</p>
						
							<p>
							Any party that receives Confidential Information in a service arrangement must keep such information confidential and not share with others including agents or third parties unless otherwise agreed.
							</p>
						  </div>

						  <div className="content-wrap-set">
							<h4>
								5. Toprow Fees
							</h4>
							{/* <p>
							<i>
							(Include information about Toprow&#39;s payment terms and percentage cuts and other fees)
							</i>
							</p> */}
							
						  </div>
						  <div className="content-wrap-set">
							<h4>
								6. Interest in Payments Accrued
							</h4>
							{/* <p>
							<i>
							(How Toprow keeps the money)
							</i>
							</p> */}
							
						  </div>
						  <div className="content-wrap-set">
							<h4>
								7. Taxes
							</h4>
							{/* <p>
							<i>
							(Information about whether Toprow charges taxes)
							</i>
							</p> */}
							
						  </div>
						  <div className="content-wrap-set">
							<h4>
								8. Exclusivity
							</h4>
							<p>
							All contracts entered into on Toprow must be completed on Toprow. You agree that you will keep all communication on Toprow. You will also contact other users only through Toprow. Acquiring jobs on Toprow and executing them outside the platform is a violation of these terms. 
							</p>
							
						  </div>
						  <div className="content-wrap-set">
							<h4>
								9. Records
							</h4>
							<p>
							You are responsible for storing and backing up your business records. Toprow has no obligation to store your content or information or to provide you with a copy of such content or information. We can only do this if such request comes within the ambit of the law.
							</p>
							
						  </div>
						  <div className="content-wrap-set">
							<h4>
								10. Disclaimer
							</h4>
							<p>
							We make no representation or warranty about our services. We cannot guarantee that our services including this website, our applications, and other products and platforms would be error-free, or uninterrupted. Toprow and its partners, affiliates or third parties acting for Toprow disclaim any warranty statutory or implied as permitted by the applicable law. We do not guarantee accuracy of data, non-infringement or merchantability and vendors, agencies or businesses working through Toprow are responsible for their own content and service.
							</p>
							
						  </div>
						  <div className="content-wrap-set">
							<h4>
								11. Limitation of Liability
							</h4>
							<p>
							By working on Toprow, you agree not to hold us liable and that we are not liable for any damages arising in connection to our services or our Terms of Service including interruptions, disruptions, delays or other glitches relating to your use of Toprow. Any liability to you is limited.
							</p>
							
						  </div>
						  <div className="content-wrap-set">
							<h4>
								12. Release
							</h4>
							<p>
							You hereby release Toprow from any liability, claims or demands connected with your use of Toprow and any disputes that may arise with other users. You hereby waive any protections against release that are provided by any applicable laws.
							</p>
							
						  </div>
						  <div className="content-wrap-set">
							<h4>
								13. Indemnification
							</h4>
							<p>
							You hereby agree to indemnify Toprow and its affiliates, agents, representatives, and third parties from all claims and liabilities relating to or arising from your use of Toprow, our products and platforms, our Terms of Service and violations therein, and services contracts entered into on Toprow by you or your agents. You indemnify, defend and hold us not liable for any claims whatsoever including Indemnified Claims and Indemnified Liabilities.
							</p>
							
						  </div>
						  <div className="content-wrap-set">
							<h4>
								14. Termination
							</h4>
							<p>
							Either you or Toprow can terminate this agreement solely without informing the other party unless otherwise agreed in writing. Neither party has to provide notice of such termination to the other. On termination, your right to use the Services is automatically revoked and your Account will be closed. Such termination does not apply to pending service contracts with other users. You agree that Toprow is not a party to contracts between you or your agents and other users.
							</p>
							
						  </div>
						  <div className="content-wrap-set in-wrap">
							<h4>
							14.2. Account Closure & Account Data
							</h4>
							<p>
							Once your Account is closed, you will lose access to the Services and retain no rights to any data you may have on Toprow. Whatever data you stored on Toprow becomes lost and you will have no access to it. Toprow will delete such data and will not be held liable for them. Toprow may also retain such data, material or information to the extent permitted or required by law and our Privacy Policy.
							</p>
							
						  </div>
						  <div className="content-wrap-set">
							<h4>
							15. Electronic Communication
							</h4>
							<p>
							You agree to be contacted electronically if Toprow or its affiliates and agents need to communicate with you. Such communication would include agreements, notices, disclosures, and other written information regarding the Services. You consent to receiving such communication by electronic means.
							</p>
							
						  </div>
					  </div>
				  </Container>
        </>
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/terms-for-professional', { headers: {
            "Accept": "application/json" }
        });

        return { props: { data: response.data.data,  } }

    } catch (err) {
        const data = false;

        return { props: { data } };
    }
}

CustomerFaq.Layout = PublicLayout;

export default CustomerFaq
